<div [formGroup]="form">
    <div formArrayName="plans">
        @for (plan of plans.controls; track plan; let i = $index) {
        <div [formGroupName]="i" class="card mb-4 border-2">
            <div class="card-header bg-light d-flex justify-content-between align-items-center">
                <h5 class="mb-0 fw-bold text-dark">Plan {{ i + 1 }}</h5>
                <button (click)="removePlan(i)"
                    class="btn bg-white text-colonial border border-2 border-colonial btn-sm d-flex align-items-center gap-1"
                    type="button">
                    <span class="material-symbols-outlined fs-6">delete</span>
                    Eliminar Plan
                </button>
            </div>
            <div class="card-body">
                <div class="row g-3 mb-4">
                    <div class="col-md-6">
                        <label class="form-label fw-bold">Nombre del Plan</label>
                        <input class="form-control" formControlName="name" placeholder="Ej: Plan I" type="text">
                    </div>
                    <div class="col-md-3">
                        <label class="form-label fw-bold">Total SA</label>
                        <div class="form-control-plaintext fw-bold text-success">
                            {{ calculateTotalSumInsured(i) | currency:'DOP':'symbol-narrow':'1.2-2' }}
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label fw-bold">Total Prima</label>
                        <div class="form-control-plaintext fw-bold text-colonial">
                            {{ calculateTotalPremium(i) | currency:'DOP':'symbol-narrow':'1.2-2' }}
                        </div>
                    </div>
                </div>

                <div class="border-top pt-3">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="mb-0 fw-bold underline-red">Coberturas del Plan</h6>
                        <button (click)="addItem(i)" class="btn btn-success btn-sm px-3" type="button">
                            <i class="bi bi-plus-circle me-1"></i>
                            Agregar Cobertura
                        </button>
                    </div>

                    <div class="table-responsive" formArrayName="items">
                        <table class="table table-hover table-bordered align-middle">
                            <thead class="bg-colonial text-white">
                                <tr>
                                    <th class="py-2">Cobertura</th>
                                    <th class="py-2">Suma Asegurada (DOP)</th>
                                    <th class="py-2">Prima (DOP)</th>
                                    <th style="width: 50px;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (item of getItems(i).controls; track item; let j = $index) {
                                <tr [formGroupName]="j">
                                    <td class="p-0 align-middle px-2" style="min-width: 250px;">
                                        <div class="d-flex align-items-center gap-1">
                                            <ng-select [items]="availableCoverages" [loading]="loading" bindLabel="name"
                                                bindValue="id" placeholder="Seleccionar Cobertura"
                                                [ngModel]="getCoverageId(i, j)" [ngModelOptions]="{standalone: true}"
                                                (ngModelChange)="onCoverageSelect(i, j, $event)"
                                                class="w-100 border-0 flex-grow-1" [clearable]="false">
                                            </ng-select>
                                            <button (click)="openCoverageModal(i, j)"
                                                class="btn btn-sm btn-outline-colonial border-0 px-2 d-flex align-items-center"
                                                type="button">
                                                <span class="material-symbols-outlined">
                                                    add_circle
                                                </span>
                                            </button>
                                        </div>
                                    </td>
                                    <td class="p-0">
                                        <input class="form-control form-control-sm border-0 shadow-none px-3 py-2"
                                            formControlName="sumInsured" mask="separator" thousandSeparator=","
                                            type="text">
                                    </td>
                                    <td class="p-0">
                                        <input class="form-control form-control-sm border-0 shadow-none px-3 py-2"
                                            formControlName="premium" mask="separator" thousandSeparator=","
                                            type="text">
                                    </td>
                                    <td class="text-center p-0">
                                        <button (click)="removeItem(i, j)" class="btn btn-link text-danger p-2"
                                            type="button">
                                            <span class="material-symbols-outlined">delete</span>
                                        </button>
                                    </td>
                                </tr>
                                }
                                @if (getItems(i).length === 0) {
                                <tr>
                                    <td class="text-center text-muted py-4 small" colspan="4">
                                        <i class="bi bi-info-circle me-1"></i> No hay coberturas configuradas para este
                                        plan.
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>

    <button (click)="addPlan()" class="btn w-100 py-3 shadow-sm bg-colonial text-white" type="button">
        <i class="bi bi-plus-square-fill me-2"></i>
        Agregar Nuevo Plan de {{ planType }}
    </button>
</div>

<app-coverage-modal [isVisible]="showCoverageModal" (closed)="onCoverageModalClosed($event)"></app-coverage-modal>